export const SVGLeft = () => (
  <svg
    style={{
      height: "156px",
      left: "-70px",
      top: "-115px",
      width: "79px",
    }}
    id="deco-left-arc-cyan"
    width="79"
    height="156"
    viewBox="0 0 79 156"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M79 0C35.3477 0.124087 7.8281e-06 34.9983 5.94844e-06 78C4.06878e-06 121.002 35.3477 155.876 79 156L79 120.566C55.2273 120.442 35.9941 101.432 35.9941 78C35.9941 54.5679 55.2273 35.5579 79 35.4341L79 0Z"
      fill="#81FFFF"
    />
  </svg>
);
